import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'; // Import the i18n configuration
import { Provider } from 'react-redux';
import store from './store';

// public/index.html is shared by every build, so its <title> cannot differ
// per module. The staging site is shown to people outside the team, where
// "OTT" means nothing and the internal product name should not appear —
// this renames the tab for that build only, leaving the others untouched.
const STAGE_PAGE_TITLE = "Demo";
if (process.env.REACT_APP_MODULE === "STAGE") {
  document.title = STAGE_PAGE_TITLE;

  // What is left of the GEO hiding the client first asked for. They have
  // since asked for the mark back on most screens (see landing.css for the
  // short list that stays hidden), so this class now carries very little —
  // but it has to be on <body> for every route, not just the landing page.
  //
  // Landing.js has its own "stage-build" class for that page's two-card
  // layout, added and removed as it mounts; this one is permanent.
  document.body.classList.add("stage-brand");
}

// Suppress debug logs in production; keep console.error and console.warn active
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
}
// The ZEGO SDK runs its own background timers (mixer heartbeat, stat
// reporting). When a room is torn down, a timer that was already scheduled
// can still fire once against the destroyed engine and throw "instance have
// destroyed, invalid call" from inside the SDK — after our own teardown has
// finished, so there is no call site of ours to catch it. Nothing is broken
// at that point (the room is already gone), but with no handler it reaches
// the dev error overlay and looks like a crash.
//
// Deliberately narrow: only this one SDK message is swallowed, and it is
// still logged. Every other error propagates as before.
const isDestroyedEngineNoise = (reason) => {
  const message = typeof reason === 'string' ? reason : reason?.message;
  return typeof message === 'string' && message.includes('instance have destroyed');
};

window.addEventListener('unhandledrejection', (event) => {
  if (isDestroyedEngineNoise(event.reason)) {
    console.warn('[Zego] Ignoring post-teardown SDK call:', event.reason?.message || event.reason);
    event.preventDefault();
  }
});

window.addEventListener('error', (event) => {
  if (isDestroyedEngineNoise(event.error || event.message)) {
    console.warn('[Zego] Ignoring post-teardown SDK call:', event.message);
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
      <Provider store={store}>
    <App />
    </Provider>
  // </React.StrictMode>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
